// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

import { environment } from 'src/environments/environment';
import { isCTSystem } from '../../shared/utils/modalityHelpers';
import { SystemOverviewService } from '../../portal/services/systemOverview.service';

@Injectable({ providedIn: 'root' })
export class CtsGantryVersionService {
  public constructor(
    private readonly systemOverviewService: SystemOverviewService,
  ) {}

  public showCTStatus(): Observable<boolean> {
    return this.systemOverviewService.systemDetails.lastSuccessfulData$
      .asObservable()
      .pipe(
        switchMap((details) => {
          const result =
            (environment.showCTStatus ?? false) &&
            isCTSystem(details.modalityId) &&
            this.isCTSoftwareVersionAllowed(details.systemSoftwareVersion);
          return of(result);
        }),
      );
  }

  private isCTSoftwareVersionAllowed(version: string): boolean {
    let result = false;
    if (version) {
      const lower = version.toLocaleLowerCase();
      result = lower.startsWith('va') || lower.startsWith('vb');
    }
    return result;
  }
}
